module.exports = __webpack_public_path__ + "img/Mask-group3.9d196eef.png";